import appApi from '../../../../api/app-api';

export const fetchCitiesOperations = async (
  setCities: (cities: string[]) => any,
) => {
  try {
    const citiesRes = await appApi.getCities();

    const cities = citiesRes.data.result.records.map(
      (item) => item.name_in_hebrew,
    );

    setCities(cities);
  } catch (e) {}
};
